export default "__VITE_ASSET__BcgNlklh__"